import React, { useState, useEffect, useRef } from "react";
import "./assets/css/common.css";
import { connect } from "react-redux";
import { AppRouter } from "./routes/router";
import { useLocation } from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "../src/components/Footer";
import { fetchData, fetchInboxMessages, fetchMessagesCounts, receivedMessage, fetchNotification, updateUserInfo } from "./redux/actions";
import { fetchCreditsBalanceRequested, fetchPlansRequested } from "./redux/actions";
import { types } from "./redux/action-types";
import { useDispatch, useSelector } from "react-redux";
import "./assets/css/common.css";
import { WS } from "./webSocket/defaultSocket";
import axios from "axios";
import { Modal } from "antd";
import { getCookie, setCookie } from "./shared/helpers";
import { Auth } from '../src/config/aws-exports'
import history from "./routes/history";
import store from "./redux/store";
import moment from "moment";
import ReactGA from "react-ga4";
import UpgradePlanModal from "./components/UpgradePlanModal/UpgradePlanModal";
import ManageSubscriptionModal from "./components/ManageSubscriptionModal/ManageSubscriptionModal";
import BillingSuccessModal from "./components/BillingSuccessModal/BillingSuccessModal";
import {
  consumeBillingCheckoutSuccess,
  getSelectedPlan,
  getSelectedPlanFromSearch,
  getPlanDetailsForSelectedPlan,
  OPEN_UPGRADE_MODAL_EVENT,
  canUseSubscriptionFeatures,
  getStoredUserProfile,
  persistSelectedPlanFromSearch,
  setBillingCheckoutReturnPath,
} from "./shared/billing";
import { fetchCreditsBannerAPI } from "./API/API";
import {
  CREDITS_BANNER_EVENT,
  CREDITS_BANNER_STORAGE_KEY,
  createCreditsBannerFromSocketAlert,
  getSocketAlertPayload,
  isCreditAlertMessage,
  isCreditsBannerUpdateMessage,
} from "./shared/creditsBanner";

// import ErrorModal from "./components/ErrorModal/errormodal";

// import WS from "./webSocket/defaultSocket"

function App(props) {
  const getStoredCreditsBanner = () => {
    try {
      return JSON.parse(localStorage.getItem(CREDITS_BANNER_STORAGE_KEY));
    } catch (error) {
      return null;
    }
  };

    // Google Analytics Initialization
  ReactGA.initialize('G-T5NQCKKG47');

  const dispatch = useDispatch();
  const [stage, seStage] = useState("");
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((error) => {
        console.warn("Service worker registration failed", error);
      });
  }

  const url = useSelector((state) => state.authReducer.url);
  const headerKey = useSelector((state) => state.candidateReducer.headerKey);
  const plans = useSelector((state) => state.plansReducer?.plans);
  const plansDirty = useSelector((state) => state.plansReducer?.plansDirty);
  const plansLoading = useSelector((state) => state.plansReducer?.loading);
  const creditsBalance = useSelector((state) => state.plansReducer?.creditsBalance);
  const creditsBalanceLoading = useSelector((state) => state.plansReducer?.creditsBalanceLoading);
  const creditsBalanceLoaded = useSelector((state) => state.plansReducer?.creditsBalanceLoaded);
  const [pathname, setPathname] = useState(window.location.pathname);
  const [showUpgradePlanModal, setShowUpgradePlanModal] = useState(false);
  const [showManageSubscriptionModal, setShowManageSubscriptionModal] = useState(false);
  const [allowCurrentPlanCheckout, setAllowCurrentPlanCheckout] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(getSelectedPlan());
  const [billingSuccessState, setBillingSuccessState] = useState(null);
  const selectedPlanDetails = getPlanDetailsForSelectedPlan(plans, selectedPlan);
  const lastCreditsBannerFetchKeyRef = useRef("");
  const subscriptionFeaturesEnabled = canUseSubscriptionFeatures(getStoredUserProfile());

  const publishCreditsBanner = (nextBanner, options = {}) => {
    const { source = "api" } = options;

    if (nextBanner == null) {
      localStorage.removeItem(CREDITS_BANNER_STORAGE_KEY);
    } else {
      const bannerToStore =
        nextBanner && typeof nextBanner === "object"
          ? {
              ...nextBanner,
              __meta: {
                source,
                updatedAt: Date.now(),
              },
            }
          : nextBanner;

      localStorage.setItem(
        CREDITS_BANNER_STORAGE_KEY,
        JSON.stringify(bannerToStore)
      );
    }

    window.dispatchEvent(
      new CustomEvent(CREDITS_BANNER_EVENT, { detail: nextBanner ?? null })
    );
  };

  const syncCreditsBanner = async (
    routePath = window.location.pathname,
    { force = false } = {}
  ) => {
    const isAuthenticated = props.authToken != null || getCookie("token") != null;
    const userProfile = getStoredUserProfile();

    if (!isAuthenticated || !canUseSubscriptionFeatures(userProfile)) {
      lastCreditsBannerFetchKeyRef.current = "";
      publishCreditsBanner(null);
      return;
    }

    const fetchKey = `${routePath}|${userProfile?.MasterAccountId ?? "null"}`;
    if (!force && lastCreditsBannerFetchKeyRef.current === fetchKey) {
      return;
    }

    lastCreditsBannerFetchKeyRef.current = fetchKey;

    try {
      const response = await fetchCreditsBannerAPI();
      const nextBanner = response?.data ?? null;
      const storedBanner = getStoredCreditsBanner();
      const storedBannerMeta = storedBanner?.__meta;
      const shouldPreserveSocketBanner =
        nextBanner == null &&
        storedBanner != null &&
        storedBannerMeta?.source === "socket";

      console.log("[CreditsBanner] /credits/banner response:", nextBanner);

      if (shouldPreserveSocketBanner) {
        console.log(
          "[CreditsBanner] preserving socket banner because API returned empty"
        );
        return;
      }

      publishCreditsBanner(nextBanner, { source: "api" });
    } catch (error) {
      lastCreditsBannerFetchKeyRef.current = "";
      console.error("Failed to fetch credits banner", error);
    }
  };

  useEffect(() => {
    persistSelectedPlanFromSearch(window.location.search);
    if (getSelectedPlanFromSearch(window.location.search)) {
      dispatch({ type: types.MARK_QUERY_PARAM_MODAL_DIRTY });
    }
    const initialPlan = getSelectedPlan();
    const pendingBillingSuccess = consumeBillingCheckoutSuccess();

    setSelectedPlan(initialPlan);
    setBillingSuccessState(pendingBillingSuccess);
    syncCreditsBanner(window.location.pathname);

    const unlisten = history.listen((location) => {
      setPathname(location.pathname);
      persistSelectedPlanFromSearch(location.search);
      if (getSelectedPlanFromSearch(location.search)) {
        dispatch({ type: types.MARK_QUERY_PARAM_MODAL_DIRTY });
      }
      const currentPlan = getSelectedPlan();
      const nextBillingSuccess = consumeBillingCheckoutSuccess();

      setSelectedPlan(currentPlan);
      if (nextBillingSuccess) {
        setBillingSuccessState(nextBillingSuccess);
        if (canUseSubscriptionFeatures(getStoredUserProfile())) {
          dispatch(fetchPlansRequested());
          dispatch(fetchCreditsBalanceRequested());
          syncCreditsBanner(location.pathname, { force: true });
        }
      }
      syncCreditsBanner(location.pathname);
    });

    return unlisten;
  }, []);

  useEffect(() => {
    syncCreditsBanner(window.location.pathname);
  }, [props.authToken]);

  useEffect(() => {
    const isAuthenticated = props.authToken != null || getCookie("token") != null;
    const userProfile = getStoredUserProfile();
    const isMasterAccount =
      userProfile?.MasterAccountId === null ||
      userProfile?.MasterAccountId === undefined;

    if (!isAuthenticated || !isMasterAccount) return;
    if (!canUseSubscriptionFeatures(userProfile)) return;
    if (!creditsBalanceLoading && !creditsBalanceLoaded) {
      dispatch(fetchCreditsBalanceRequested());
    }
  }, [props.authToken, creditsBalanceLoading, creditsBalanceLoaded, dispatch]);

  useEffect(() => {
    if (!getSelectedPlanFromSearch(window.location.search)) return;
    if (props.authToken == null && getCookie("token") == null) return;
    if (!subscriptionFeaturesEnabled) return;

    if (plansDirty && !plansLoading) {
      dispatch(fetchPlansRequested());
    }

    if (!creditsBalanceLoading && !creditsBalanceLoaded) {
      dispatch(fetchCreditsBalanceRequested());
    }
  }, [
    creditsBalanceLoaded,
    creditsBalanceLoading,
    dispatch,
    plansDirty,
    plansLoading,
    props.authToken,
    subscriptionFeaturesEnabled,
  ]);

  useEffect(() => {
    const handleOpenUpgradeModal = (event) => {
      const nextSelectedPlan =
        event?.detail?.selectedPlan || getSelectedPlan() || "starter";
      const nextModalType = event?.detail?.modalType || "upgrade";
      const nextAllowCurrentPlanCheckout =
        event?.detail?.allowCurrentPlanCheckout === true;

      if (!canUseSubscriptionFeatures(getStoredUserProfile())) {
        setShowUpgradePlanModal(false);
        setShowManageSubscriptionModal(false);
        return;
      }

      setBillingCheckoutReturnPath();
      setSelectedPlan(nextSelectedPlan);
      setShowUpgradePlanModal(nextModalType === "upgrade");
      setShowManageSubscriptionModal(nextModalType === "manageSubscription");
      setAllowCurrentPlanCheckout(nextAllowCurrentPlanCheckout);
    };

    window.addEventListener(OPEN_UPGRADE_MODAL_EVENT, handleOpenUpgradeModal);

    return () => {
      window.removeEventListener(
        OPEN_UPGRADE_MODAL_EVENT,
        handleOpenUpgradeModal
      );
    };
  }, []);

  const hideFooter =
    pathname.includes('/internal-detail/') ||
    pathname.includes('/external-detail/') ||
    pathname.startsWith('/postjob') ||
    pathname.startsWith('/postajob') ||
    pathname.startsWith('/about-yourself') ||
    pathname.startsWith('/about-your-company') ||
    pathname.startsWith('/create-your-first-job') ||
    pathname.startsWith('/external') ||
    pathname.startsWith('/query') ||
    pathname.includes('/myteams') ||
    pathname.includes('/verify-email') ||
    pathname.includes('/manage-invites') ||
    pathname.includes('/jobdetail');

  const hideHeader =
    pathname.includes('/verify-email') ||
    localStorage.getItem('emailVerified') === 'false';
  let userProfile = localStorage.getItem("userProfile");
  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));

  useEffect(() => {
    if (userProfile1?.AccountId) {
      WS.init(userProfile1?.AccountId);
      WS.onMessage(({ data }) => {
        try {
          const message = JSON.parse(data);

          if (isCreditAlertMessage(message)) {
            if (!canUseSubscriptionFeatures(getStoredUserProfile())) {
              publishCreditsBanner(null);
              return;
            }

            console.log("[CreditsBanner] socket event received:", message);
            const nextBanner = createCreditsBannerFromSocketAlert(message);

            if (nextBanner) {
              publishCreditsBanner(nextBanner, { source: "socket" });
            }

            if (isCreditsBannerUpdateMessage(message)) {
              syncCreditsBanner(window.location.pathname, { force: true });
            }

            dispatch(fetchCreditsBalanceRequested());
          }
        } catch (error) {
          console.warn("Failed to parse credits banner socket payload", error);
        }
      });
    }
  }, [userProfile1?.AccountId]);

   useEffect(() => {
      if (userProfile1?.AccountTypeCode == "TAL" && props?.authToken) {
        window.location.replace("/talent/auth");
      }
    }, [userProfile1])


  const receiveStage = (stage) => {
    seStage(stage);
  };

  useEffect(() => {

    // Google Analytics hit page view event
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    
    refreshLoginToken()
    // async function AuthCheck() {
    //   let session = null;

    //   try {
    //     if (getCookie("token") !== null && getCookie("token").length > 0) {
    //       const myToken = getCookie("token");
    //       const cognitoUser = await Auth.currentAuthenticatedUser();
    //       const currentSession = await Auth.currentSession();
    //       console.log('token???',cognitoUser, "&&", currentSession,'&&',myToken )
    //       cognitoUser.refreshSession(
    //         currentSession.refreshToken,
    //         (err, session) => {
    //           // console.log("session", err, session);
    //           const Token = session.idToken.jwtToken;
    //           // do whatever you want to do now :)
    //           // console.log("authToken", talentToken);
    //           setCookie("token", Token, true);
    //           // props.profileDetails(Token);
    //           // props.sendAuthToken(Token);
    //         }
    //       );
    //     }
    //   } catch (err) {
    //     history.push("/login")
    //   }
    // }
    // AuthCheck();
  }, []);

  async function refreshLoginToken() {
    try {
      const currentSession = await Auth.currentSession();

        const cognitoUser = await Auth.currentAuthenticatedUser();
        cognitoUser.refreshSession(
          currentSession.refreshToken,
          (err, session) => {
            const Token = session.idToken.jwtToken;

            dispatch(updateUserInfo(Token))
            setCookie("token", Token);
          }
        );
    
    } catch (error) {
      console.log('refresh err ===>', error);
    }
  }

  // axios.interceptors.response.use(
  //   (res) => {
  //      // Add configurations here
  //      if (res.status === 200) {
  //         console.log('API Successfully');
  //      }
  //      return res;
  //   },
  //   (err) => {
  //     //  return Promise.reject(err);
  //     //  console.log('APIerr API failed', err);
  //      if(err) {
  //       setAPIerr(true)
  //       setErrormsg(err)
  //     }
  //   }
  // );

  return (
    <React.Fragment>
      <UpgradePlanModal
        visible={subscriptionFeaturesEnabled && showUpgradePlanModal}
        selectedPlan={selectedPlan}
        planData={selectedPlanDetails}
        onClose={() => setShowUpgradePlanModal(false)}
      />
      {subscriptionFeaturesEnabled && <ManageSubscriptionModal
        visible={showManageSubscriptionModal}
        onClose={() => {
          setShowManageSubscriptionModal(false);
          setAllowCurrentPlanCheckout(false);
        }}
        plans={plans}
        creditsBalance={creditsBalance}
        allowCurrentPlanCheckout={allowCurrentPlanCheckout}
        loading={Boolean(plansDirty) || creditsBalanceLoading || !creditsBalanceLoaded}
      />}
      <BillingSuccessModal
        open={Boolean(billingSuccessState)}
        title={billingSuccessState?.title}
        message={billingSuccessState?.message}
        onClose={() => setBillingSuccessState(null)}
      />
      {!hideHeader && <Header
        changeStage={receiveStage}
        stage={stage}
        userProfile={userProfile}
      />}
      <AppRouter authToken={props.authToken} shareStage={receiveStage} />

      {!hideFooter && <Footer key={headerKey} />}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    authToken: state.authReducer.user.authToken,
    loading: state.profileReducer.loading,
    user: state.profileReducer.user,
    error: state.profileReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (params) => {
      dispatch(fetchData(params));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
